import CursorListI from '../types.ts';

const getItems: CursorListI['getItems'] = function () {
    const { cursorList } = this.props;

    return [...cursorList];
};

export default getItems;
